import React from 'react';

import StockFilterRange from '@/components/StockFilterRange';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarEnginePower,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';

function EnginePowerFilter() {
  const dispatch = useTypedDispatch();
  const enginePower =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEnginePower;

  const handleBlurEnginePower = (enginePower: RangeType) => {
    dispatch(setCarEnginePower(enginePower));
    dispatch(setPage(1));
  };

  return (
    <StockFilterRange
      label="Мощность двигателя, л.c"
      values={enginePower}
      onBlur={handleBlurEnginePower}
    />
  );
}

export default EnginePowerFilter;
